<template>
  <el-dialog
    :visible.sync="dialogVisible"
    :title="dialogTitle"
    width="68%"
    :before-close="handleClose"
    custom-class="factory-form-dialog"
  >
    <el-tabs v-model="activeTab" type="card">
      <!-- ========== 基本信息 ========== -->
      <el-tab-pane label="基本信息" name="basic">
        <el-form
          ref="formRef"
          v-loading="formLoading"
          :model="formData"
          :rules="formRules"
          label-width="140px"
        >
          <el-row :gutter="20">
            <el-col :span="12">
              <el-form-item label="合作伙伴LOGO" prop="image">
                <FormImgUpload
                  :url="formData.image"
                  @upload="upload"
                  :limit="1"
                  :maxSize="20"
                  :accept="'.png,.jpg,.jpeg,.svg,.tiff'"
                  :multiple="true"
                  :disabled="formType == 'view'"
                />
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="视频" prop="video">
                <FormVideoUpload
                  :url="formData.video"
                  @upload="uploadVideo"
                  :limit="3"
                  :maxSize="500"
                  :accept="'.mp4,.webm,.avi'"
                  :multiple="false"
                  :disabled="formType == 'view'"
                />
                <span style="color: #c0c1c3">
                  建议尺寸：750px*960px，最大500M，视频格式：.mp4,.webm,.avi
                </span>
              </el-form-item>
            </el-col>
          </el-row>

          <el-form-item label="企业伙伴查询" prop="nameKey">
            <div class="flex align-items">
              <el-input
                v-model="formData.nameKey"
                placeholder="请输入"
                style="width: 400px"
                maxlength="50"
                :disabled="formType == 'view' || formType == 'update'"
              ></el-input>
              <el-button
                type="primary"
                class="marginLeft10"
                :loading="queryLoading"
                :disabled="formType == 'view'"
                @click="handleQueryInfo"
                >查询信息</el-button
              >
              <span
                class="marginLeft10"
                style="color: #f59a23; font-size: 12px"
              >
                根据盘厂名称从良信运营管平台获取盘厂信息
              </span>
            </div>
          </el-form-item>

          <el-form-item label="合作伙伴名称" prop="name">
            <el-input
              v-model="formData.name"
              placeholder="查询后自动回填"
              style="width: 400px"
              maxlength="50"
              :disabled="true"
            ></el-input>
          </el-form-item>

          <el-form-item label="企业信用代码" prop="creditCode">
            <el-input
              v-model="formData.creditCode"
              placeholder="自动获取"
              style="width: 400px"
              maxlength="50"
              :disabled="true"
            ></el-input>
          </el-form-item>

          <!-- 授权类型 = 现有的 equityClassifyIds（不动其逻辑） -->
          <el-form-item label="授权类型" prop="equityClassifyIds">
            <el-checkbox-group
              v-model="formData.equityClassifyIds"
              @change="handleSort"
              :disabled="true"
            >
              <el-checkbox
                v-for="item in classifyList"
                :key="item.id"
                :label="item.id"
                >{{ item.name }}</el-checkbox
              >
            </el-checkbox-group>
          </el-form-item>
          <!-- 保留原有：权益分类证书 + 签约/到期日期（不动） -->
          <el-row :gutter="20" type="flex" style="flex-wrap: wrap">
            <el-col
              :span="12"
              v-for="(item, index) in formData.equityClassifyList"
              :key="index"
            >
              <div
                class="flex video_box"
                style="margin-left: 0; margin-bottom: 20px"
              >
                <div class="flex">
                  <span class="video_span" style="display: inline-block">
                    {{ item.name }}
                    <span class="marginLeft10">证书</span>
                  </span>
                  <FormImgUpload
                    :url="item.certImage"
                    @upload="uploadEquity"
                    :limit="1"
                    :maxSize="20"
                    :accept="'.png,.jpg,.jpeg,.svg,.tiff'"
                    :multiple="true"
                    :indexof="index"
                  />
                </div>
                <div>
                  <div>
                    <span class="video_span" style="display: inline-block">
                      <span style="color: #f56c6c">* </span>
                      签约日期
                    </span>
                    <el-date-picker
                      v-model="item.startTime"
                      type="date"
                      :clearable="true"
                      placeholder="选择日期"
                      :disabled="true"
                      style="width: 200px"
                    />
                  </div>
                  <div>
                    <span
                      class="video_span"
                      style="display: inline-block; margin-top: 20px"
                    >
                      <span style="color: #f56c6c">* </span>
                      到期日期
                    </span>
                    <el-date-picker
                      v-model="item.endTime"
                      type="date"
                      :clearable="true"
                      placeholder="选择日期"
                      :disabled="true"
                      style="width: 200px"
                    />
                  </div>
                </div>
              </div>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <el-form-item label="良信负责人" prop="lxPrincipal">
                <el-input
                  v-model="formData.lxPrincipal"
                  placeholder="自动获取"
                  style="width: 400px"
                  maxlength="20"
                  :disabled="true"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="良信负责人手机号" prop="lxPrincipalPhone">
                <el-input
                  v-model="formData.lxPrincipalPhone"
                  placeholder="自动获取"
                  style="width: 400px"
                  maxlength="11"
                  :disabled="true"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="所在大区" prop="region">
                <el-select
                  v-model="formData.region"
                  placeholder="请选择"
                  style="width: 400px"
                  :disabled="formType == 'view'"
                >
                  <el-option
                    v-for="item in regionOptions"
                    :key="item.value"
                    :value="item.value"
                    :label="item.label"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="所在地区部" prop="regionDept">
                <el-input
                  v-model="formData.regionDept"
                  placeholder="请输入"
                  maxlength="50"
                  :disabled="formType == 'view'"
                  style="width: 400px"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="授权合作类型" prop="authCooperationType">
                <el-select
                  v-model="formData.authCooperationType"
                  placeholder="请选择"
                  style="width: 400px"
                  :disabled="formType == 'view'"
                >
                  <el-option
                    v-for="item in cooperateTypeOptions"
                    :key="item.value"
                    :value="item.value"
                    :label="item.label"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="授权城市" prop="authCity">
                <el-cascader
                  v-model="formData.authCity"
                  :options="cityOptions"
                  placeholder="请选择省/市"
                  style="width: 400px"
                  clearable
                  :disabled="formType == 'view'"
                ></el-cascader>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="对应LWS良仓" prop="lwsWarehouse">
                <el-select
                  v-model="formData.lwsWarehouse"
                  placeholder="多选（最多5个）"
                  style="width: 400px"
                  multiple
                  :filterable="true"
                  :multiple-limit="5"
                  :disabled="formType == 'view'"
                >
                  <el-option
                    v-for="item in wsOptions"
                    :key="item.value"
                    :value="item.value"
                    :label="item.label"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="12" v-if="formType == 'view'">
              <el-form-item label="负责人/决策人" prop="decisionMaker">
                <el-input
                  v-model="formData.decisionMaker"
                  placeholder="请输入"
                  maxlength="50"
                  :disabled="formType == 'view'"
                  style="width: 400px"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12" v-if="formType == 'view'">
              <el-form-item label="负责人联系方式" prop="decisionMakerPhone">
                <el-input
                  v-model="formData.decisionMakerPhone"
                  placeholder="请输入"
                  maxlength="11"
                  :disabled="formType == 'view'"
                  style="width: 400px"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12" v-if="formType == 'view'">
              <el-form-item label="公司经营地址" prop="businessAddress">
                <el-input
                  v-model="formData.businessAddress"
                  placeholder="请输入"
                  maxlength="100"
                  :disabled="formType == 'view'"
                  style="width: 400px"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12" v-if="formType == 'view'">
              <el-form-item label="生产的盘柜类型" prop="cabinetType">
                <el-input
                  v-model="formData.cabinetType"
                  placeholder="请输入"
                  maxlength="100"
                  :disabled="formType == 'view'"
                  style="width: 400px"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12" v-if="formType == 'view'">
              <el-form-item label="主要行业" prop="mainIndustry">
                <el-input
                  v-model="formData.mainIndustry"
                  placeholder="请输入"
                  maxlength="100"
                  :disabled="formType == 'view'"
                  style="width: 400px"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12" v-if="formType == 'view'">
              <el-form-item label="主要客户" prop="mainCustomer">
                <el-input
                  v-model="formData.mainCustomer"
                  placeholder="请输入"
                  maxlength="100"
                  :disabled="formType == 'view'"
                  style="width: 400px"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12" v-if="formType == 'view'">
              <el-form-item label="人员数量" prop="staffCount">
                <el-select
                  v-model="formData.staffCount"
                  placeholder="请选择"
                  :disabled="formType == 'view'"
                  style="width: 400px"
                  clearable
                >
                  <el-option
                    v-for="item in staffCountOptions"
                    :key="item.value"
                    :value="item.value"
                    :label="item.label"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="12" v-if="formType == 'view'">
              <el-form-item label="友商合作情况" prop="competitorCooperation">
                <el-input
                  v-model="formData.competitorCooperation"
                  placeholder="请输入"
                  maxlength="100"
                  :disabled="formType == 'view'"
                  style="width: 400px"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="8" v-if="isL1Selected">
              <el-form-item label="已申请License" prop="usedLicense">
                <el-input
                  v-model="formData.usedLicense"
                  placeholder="自动获取"
                  :disabled="true"
                  style="width: 400px"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12" v-if="isL2Selected">
              <el-form-item label="L-Design账号" prop="ldesignAccount" required>
                <el-input
                  v-model="formData.ldesignAccount"
                  placeholder="自动获取"
                  :disabled="true"
                  style="width: 400px"
                ></el-input>
              </el-form-item>
            </el-col>
            <!-- <el-col :span="12" v-if="isL2Selected">
              <el-form-item label="质检次数" prop="qualityInspectionsNum" required>
                <el-input
                  v-model="formData.qualityInspectionsNum"
                  placeholder="自动获取"
                  :disabled="true"
                  style="width: 400px"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12" v-if="isL2Selected">
              <el-form-item label="合格次数" prop="qualityInspectionsPassNum" required>
                <el-input
                  v-model="formData.qualityInspectionsPassNum"
                  placeholder="自动获取"
                  :disabled="true"
                  style="width: 400px"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12" v-if="isL2Selected">
              <el-form-item label="不合格次数" prop="unqualifiedQualityInspectionsNum" required>
                <el-input
                  v-model="formData.unqualifiedQualityInspectionsNum"
                  placeholder="自动获取"
                  :disabled="true"
                  style="width: 400px"
                ></el-input>
              </el-form-item>
            </el-col> -->
          </el-row>

          <!-- <el-form-item label="盘厂详情" prop="details">
            <FormEditor
              v-if="dialogVisible"
              :content="formData.details"
              @change="editoChange"
              :disabled="formType == 'view'"
              style="width: 80%"
            />
          </el-form-item> -->
        </el-form>
      </el-tab-pane>

      <!-- ========== 合同信息 ========== -->
      <el-tab-pane label="合同信息" name="contract">
        <div class="flex align-items marginBottom10">
          <span>协议编号</span>
          <el-input
            v-model="contractFilter.contractCode"
            size="small"
            placeholder="根据搜索"
            style="width: 200px"
            class="marginLeft10"
          />
          <span class="marginLeft10">授权类型</span>
          <el-select
            v-model="contractFilter.contractLevel"
            size="small"
            placeholder="请选择"
            clearable
            style="width: 160px"
            class="marginLeft10"
          >
            <el-option label="L1" :value="0" />
            <el-option label="L2" :value="1" />
            <el-option label="L3" :value="2" />
            <el-option label="L4" :value="3" />
          </el-select>
          <el-button
            class="marginLeft10"
            size="small"
            @click="resetContractSearch"
            >重置</el-button
          >
          <el-button type="primary" size="small" @click="getContractList"
            >查询</el-button
          >
        </div>
        <el-table
          :data="contractList"
          v-loading="contractLoading"
          border
          size="small"
        >
          <el-table-column prop="contractCode" label="合同编号" align="center">
            <template slot-scope="{ row }">
              <el-link
                type="primary"
                :underline="false"
                class="contract-code-link"
                @click="
                  handlePreviewContractUrl(
                    row.authContractFile ||
                      row.otherContractFile ||
                      row.thirdPartyContractFile,
                    row.contractCode
                  )
                "
                >{{ row.contractCode }}</el-link
              >
            </template>
          </el-table-column>
          <el-table-column label="合同类型" align="center">
            <template slot-scope="{ row }">
              {{
                row.authContractFile
                  ? "授权合同文件"
                  : row.otherContractFile
                  ? "其他合同文件"
                  : row.thirdPartyContractFile
                  ? "三方合同"
                  : ""
              }}
            </template>
          </el-table-column>
          <el-table-column label="授权等级" align="center">
            <template slot-scope="{ row }">
              {{ contractLevelMap[row.contractLevel] || "" }}
            </template>
          </el-table-column>
          <el-table-column label="授权模式" align="center">
            <template slot-scope="{ row }">
              {{
                row.authMode == 0
                  ? "定额永许"
                  : row.authMode == 1
                  ? "会员无限"
                  : ""
              }}
            </template>
          </el-table-column>
          <el-table-column label="授权状态" align="center">
            <template slot-scope="{ row }">
              {{
                row.authStatus == 1 ? "有效" : row.authStatus == 2 ? "休眠" : ""
              }}
            </template>
          </el-table-column>
          <el-table-column prop="startTime" label="授权起始日" align="center" />
          <el-table-column prop="endTime" label="授权到期日" align="center" />
        </el-table>
      </el-tab-pane>
    </el-tabs>

    <template #footer>
      <div class="flex" style="justify-content: center">
        <el-button
          :disabled="formLoading"
          type="primary"
          @click="submitForm"
          v-if="formType != 'view'"
          >确 定</el-button
        >
        <el-button @click="dialogVisible = false">
          {{ formType == "view" ? "关 闭" : "取 消" }}
        </el-button>
      </div>
    </template>

    <!-- 合同 PDF 预览 弹窗 -->
    <el-dialog
      :visible.sync="contractPreviewVisible"
      :title="contractPreviewTitle"
      width="80%"
      top="5vh"
      append-to-body
      :close-on-click-modal="false"
      custom-class="contract-preview-dialog"
    >
      <div v-loading="contractPreviewLoading" class="contract-preview-body">
        <iframe
          v-if="contractPreviewUrl"
          :src="contractPreviewUrl"
          frameborder="0"
          class="contract-preview-iframe"
          @load="contractPreviewLoading = false"
        ></iframe>
        <div v-else class="contract-preview-empty">暂无合同文件</div>
      </div>
      <template #footer>
        <div class="flex" style="justify-content: center">
          <el-button
            type="primary"
            :disabled="!contractPreviewUrl"
            @click="openContractInNewTab"
            >新窗口打开</el-button
          >
          <el-button @click="contractPreviewVisible = false">关 闭</el-button>
        </div>
      </template>
    </el-dialog>
  </el-dialog>
</template>
<script>
import { Message } from "element-ui";
import {
  factoryManageAdd,
  factoryManageUpdate,
  factoryManageDetail,
  factoryManageInfoQuery,
  factoryContractList,
} from "@/api/factory/manage";
import FormImgUpload from "@/components/formComponents/formImgUpload";
import { mobilePhoneRule } from "@/utils/formRules";
import dayjs from "dayjs";
import FormEditor from "@/components/formComponents/formEditor";
import FormVideoUpload from "@/components/formComponents/formVideoUpload";
import Import from "@/components/import";
import {
  OCooperateType,
  OLwsDealer,
  OStaffCount,
} from "@/enums/beCurrent/EBeCurrent";
import { oaApproverRegionList } from "@/api/factory/oaApprover";
import areaData from "@/style/address/a.json";
export default {
  name: "index",
  components: {
    FormImgUpload,
    FormEditor,
    FormVideoUpload,
    Import,
  },
  props: {
    classifyList: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      // 弹窗相关
      dialogVisible: false, // 控制新增/编辑/查看主弹窗的显示与隐藏
      dialogTitle: "", // 主弹窗的标题
      formLoading: false, // 控制表单提交时的 loading 状态
      formType: "", // 表单的操作类型：'create' 新增, 'edit' 编辑, 'view' 查看
      queryLoading: false, // 控制“查询信息”按钮的 loading 状态
      activeTab: "basic", // 当前选中的 Tab 页签，默认选中"基本信息"

      // 选项数据
      regionOptions: [], // 所在大区下拉选项
      cooperateTypeOptions: OCooperateType, // 授权合作类型下拉选项
      cityOptions: [], // 城市级联选择静态选项
      wsOptions: OLwsDealer, // LWS良仓下拉选项
      staffCountOptions: OStaffCount, // 人员数量下拉选项

      // 表单数据与校验
      formData: this.buildEmptyForm(), // 主表单数据
      formRules: {
        // 主表单校验规则
        name: [
          { required: true, message: "请输入合作伙伴名称", trigger: "blur" },
        ],
        creditCode: [
          { required: true, message: "请查询获取", trigger: "blur" },
        ],
        lxPrincipal: [
          { required: true, message: "请查询获取", trigger: "blur" },
        ],
        lxPrincipalPhone: [
          { required: true, message: "请查询获取", trigger: "blur" },
          ...mobilePhoneRule,
        ],
        region: [{ required: true, message: "请选择", trigger: "change" }],
        regionDept: [{ required: true, message: "请输入", trigger: "blur" }],
        authCooperationType: [
          { required: true, message: "请选择", trigger: "change" },
        ],
        authCity: [{ required: true, message: "请选择", trigger: "blur" }],
        lwsWarehouse: [
          { required: true, message: "请选择", trigger: "change" },
        ],
        decisionMaker: [{ required: true, message: "请输入", trigger: "blur" }],
        decisionMakerPhone: [
          { required: true, message: "请输入", trigger: "blur" },
          ...mobilePhoneRule,
        ],
        businessAddress: [
          { required: true, message: "请输入", trigger: "blur" },
        ],
        cabinetType: [{ required: true, message: "请输入", trigger: "blur" }],
        mainIndustry: [{ required: true, message: "请输入", trigger: "blur" }],
        mainCustomer: [{ required: true, message: "请输入", trigger: "blur" }],
        competitorCooperation: [
          { required: true, message: "请输入", trigger: "blur" },
        ],
        staffCount: [{ required: true, message: "请选择", trigger: "change" }],
        ldesignAccount: [
          { required: true, message: "请查询获取", trigger: "change" },
        ],
        qualityInspectionsNum: [
          { required: true, message: "请查询获取", trigger: "change" },
        ],
        qualityInspectionsPassNum: [
          { required: true, message: "请查询获取", trigger: "change" },
        ],
        unqualifiedQualityInspectionsNum: [
          { required: true, message: "请查询获取", trigger: "change" },
        ],
      },

      // ===== 合同信息 Tab =====
      contractFilter: {
        // 合同信息查询条件参数
        contractCode: "",
        contractLevel: "",
      },
      contractList: [], // 合同信息表格数据列表
      contractLoading: false, // 合同信息表格 loading 状态
      contractPage: {
        // 合同信息分页配置
        currentPage: 1,
        pageSize: 999,
        total: 0,
      },
      contractLevelMap: {
        // 合同等级映射字典
        0: "L1",
        1: "L2",
        2: "L3",
        3: "L4",
      },

      // ===== 合同 PDF 预览 =====
      contractPreviewVisible: false, // 合同 PDF 预览弹窗的显示与隐藏
      contractPreviewLoading: false, // 合同预览加载时的 loading 状态
      contractPreviewTitle: "合同预览", // 合同预览弹窗的标题
      contractPreviewUrl: "", // 待预览合同 PDF 的文件地址
    };
  },
  computed: {
    /** 判断「授权类型」中是否勾选了 L1（基于 classifyList 中 name === 'L1' 的 id） */
    isL1Selected() {
      const target = this.classifyList.find((c) => c.name === "L1");
      return (
        target &&
        Array.isArray(this.formData.equityClassifyIds) &&
        this.formData.equityClassifyIds.includes(target.id)
      );
    },
    isL2Selected() {
      const target = this.classifyList.find((c) => c.name === "L2");
      return (
        target &&
        Array.isArray(this.formData.equityClassifyIds) &&
        this.formData.equityClassifyIds.includes(target.id)
      );
    },
  },
  watch: {},
  created() {
    this.getRegionList();
    this.cityOptions = this.buildCityOptions();
  },
  methods: {
    /** 构造一个空的 formData，方便复用 */
    buildEmptyForm() {
      return {
        equityClassifyIds: [],
        equityClassifyList: [],
        name: "",
        nameKey: "",
        image: [],
        video: [],
        creditCode: "",
        lxPrincipal: "",
        lxPrincipalPhone: "",
        region: "",
        regionDept: "",
        authCooperationType: "",
        authCity: [],
        lwsWarehouse: [],
        decisionMaker: "",
        decisionMakerPhone: "",
        businessAddress: "",
        mainIndustry: "",
        mainCustomer: "",
        cabinetType: "",
        competitorCooperation: "",
        staffCount: "",
        details: "",
        // L1
        totalLicense: "",
        usedLicense: "",
        availableLicense: "",
        // L2
        ldesignAccount: "",
        qualityInspectionsNum: "",
        qualityInspectionsPassNum: "",
        unqualifiedQualityInspectionsNum: "",
        // 兼容旧字段
        cooperate: "",
        phone: "",
        contacts: "",
        address: "",
        abbr: "",
        rebateCompleteRate: "",
        purchaseOrderAmount: "",
        details: "",
      };
    },

    /** 打开弹窗 */
    async open(type, id) {
      this.dialogVisible = true;
      this.activeTab = "basic";
      this.dialogTitle =
        type === "view" ? "详情" : type === "create" ? "新增" : "修改";
      this.formType = type;
      this.resetForm();

      if (id) {
        this.formLoading = true;
        try {
          const { data } = await factoryManageDetail(id);
          const equityList = data.equityClassifyList || [];
          const l1Item = equityList.find(
            (item) => item.equityClassifyName === "L1" || item.name === "L1"
          );
          const l2Item = equityList.find(
            (item) => item.equityClassifyName === "L2" || item.name === "L2"
          );

          this.formData = {
            ...this.buildEmptyForm(),
            ...data,
            nameKey: data.name || "",
            equityClassifyIds: this.parseStringToArray(data.equityClassifyIds),
            image: this.parseStringToArray(data.image),
            video: this.parseStringToArray(data.video),
            lwsWarehouse: this.parseWarehouse(data.lwsWarehouse || data.ws),
            ws: this.parseWarehouse(data.lwsWarehouse || data.ws),
            authCity: data.authProvince
              ? [data.authProvince, data.authCity].filter(Boolean)
              : this.parseAuthCity(data.authCity),
            equityClassifyList: equityList.map((item) => ({
              ...item,
              certImage: this.parseStringToArray(item.certImage),
              id: item.equityClassifyId,
              name: item.equityClassifyName,
              endTime: this.parseDateForSafari(item.endTime),
              startTime: this.parseDateForSafari(item.startTime),
            })),
            // L1/L2 回显适配
            usedLicense: l1Item
              ? l1Item.appliedLicense ??
                l1Item.usedLicense ??
                l1Item.usedLicenseNum ??
                data.usedLicense ??
                ""
              : data.usedLicense ?? "",
            ldesignAccount: l2Item
              ? l2Item.ldesignAccount ?? ""
              : data.ldesignAccount ?? "",
            qualityInspectionsNum: l2Item ? l2Item.qualityInspectionsNum : "",
            qualityInspectionsPassNum: l2Item
              ? l2Item.qualityInspectionsPassNum
              : "",
            unqualifiedQualityInspectionsNum: l2Item
              ? l2Item.unqualifiedQualityInspectionsNum
              : "",
          };
          this.contractList = data.contractList || [];
          this.getContractList();
        } finally {
          this.formLoading = false;
        }
      }
    },

    /** 点击「查询信息」 */
    async handleQueryInfo() {
      if (!this.formData.nameKey || !this.formData.nameKey.trim()) {
        Message.warning("请先输入查询伙伴名称");
        return;
      }
      this.queryLoading = true;
      let searchForm = {};
      searchForm.factoryName = this.formData.nameKey;
      // if (this.formType != "create") {
      //   searchForm.creditCode = this.formData.creditCode;
      // }
      try {
        const res = await factoryManageInfoQuery({
          ...searchForm,
        });
        if (res && res.code === 200 && res.data) {
          const apiData = res.data;
          let rawEquityList =
            apiData.factoryEquityClassifyList ||
            apiData.equityClassifyList ||
            [];

          // 兜底逻辑：如果缺少 ID，尝试通过 equityClassifyName 反查分类字典来补齐 ID
          const equityClassifyList = rawEquityList.map((item) => {
            if (!item.equityClassifyId && item.equityClassifyName) {
              const matched = this.classifyList.find(
                (c) => c.name === item.equityClassifyName
              );
              if (matched) {
                item.equityClassifyId = matched.id;
              }
            }
            return item;
          });
          const firstEquity = equityClassifyList[0] || {};
          const l2Equity =
            equityClassifyList.find(
              (item) => item.equityClassifyName === "L2" || item.name === "L2"
            ) || {};

          // --- 配置化映射引擎 ---
          // 字段映射规则字典说明：
          // target: 表单本地绑定的目标字段名
          // sources: 接口返回的字段池（引擎会从左到右按优先级查找，可用于兼容不同接口下的同一业务命名）
          // fallback: 可选。如果接口全未命中，则使用此值强行覆盖。若不配置，则原封不动保留表单已有的数据（防覆盖保护）
          const fieldMappingConfig = [
            { target: "name", sources: ["name"] },
            { target: "creditCode", sources: ["creditCode"], fallback: "" },
            {
              target: "lxPrincipal",
              sources: ["lxPrincipal", "leaderName"],
              fallback: "",
            },
            {
              target: "lxPrincipalPhone",
              sources: ["lxPrincipalPhone", "leaderPhone"],
              fallback: "",
            },
            { target: "region", sources: ["region"] },
            { target: "regionDept", sources: ["regionDept"] },
            {
              target: "authCooperationType",
              sources: ["authCooperationType"],
            },
            { target: "decisionMaker", sources: ["decisionMaker"] },
            { target: "decisionMakerPhone", sources: ["decisionMakerPhone"] },
            { target: "businessAddress", sources: ["businessAddress"] },
            { target: "mainIndustry", sources: ["mainIndustry"] },
            { target: "mainCustomer", sources: ["mainCustomer"] },
            { target: "cabinetType", sources: ["cabinetType"] },
            {
              target: "competitorCooperation",
              sources: ["competitorCooperation"],
            },
            { target: "staffCount", sources: ["staffCount"] },
            { target: "details", sources: ["details"] },
          ];

          const newFormData = { ...this.formData };

          fieldMappingConfig.forEach(({ target, sources, fallback }) => {
            let valueFromApi = null;
            for (let src of sources) {
              if (
                apiData[src] !== undefined &&
                apiData[src] !== null &&
                apiData[src] !== ""
              ) {
                valueFromApi = apiData[src];
                break;
              }
            }
            if (valueFromApi !== null) {
              newFormData[target] = valueFromApi;
            } else if (fallback !== undefined) {
              newFormData[target] = fallback;
            }
          });

          // 复杂结构单独解析
          newFormData.image = this.parseStringToArray(
            apiData.image,
            newFormData.image
          );
          newFormData.authCity = this.parseAuthCity(
            apiData.authCity || newFormData.authCity
          );
          newFormData.lwsWarehouse = this.parseWarehouse(
            apiData.lwsWarehouse || apiData.ws,
            newFormData.lwsWarehouse
          );

          // 其他复合列表逻辑保留
          newFormData.equityClassifyIds = equityClassifyList
            .map((item) => item.equityClassifyId)
            .filter(Boolean);
          newFormData.equityClassifyList = equityClassifyList.map((item) => ({
            ...item,
            id: item.equityClassifyId,
            name: item.equityClassifyName,
            startTime: this.parseDateForSafari(item.startTime || ""),
            endTime: this.parseDateForSafari(item.endTime || ""),
            certImage: this.parseStringToArray(item.certImage),
          }));
          newFormData.contractList =
            apiData.factoryContractList || apiData.contractList || [];
          newFormData.totalLicense =
            apiData.totalLicense ??
            this.sumLicense(
              firstEquity.usedLicenseNum,
              firstEquity.ableLicenseNum
            );
          newFormData.usedLicense =
            apiData.usedLicense ?? firstEquity.usedLicenseNum ?? "";
          newFormData.availableLicense =
            apiData.availableLicense ?? firstEquity.ableLicenseNum ?? "";
          newFormData.ldesignAccount =
            apiData.ldesignAccount || l2Equity.ldesignAccount || "";
          newFormData.qualityInspectionsNum =
            apiData.qualityInspectionsNum ?? "";
          newFormData.qualityInspectionsPassNum =
            l2Equity.qualityInspectionsPassNum ?? "";
          newFormData.unqualifiedQualityInspectionsNum =
            l2Equity.unqualifiedQualityInspectionsNum ?? "";
          // 一次性赋值触发响应式更新
          this.formData = newFormData;
          this.getContractList();
          this.$nextTick(() => {
            this.$refs.formRef &&
              this.$refs.formRef.clearValidate([
                "name",
                "creditCode",
                "lxPrincipal",
                "lxPrincipalPhone",
              ]);
          });
          Message.success("获取成功");
        } else {
          // Message.warning((res && res.msg) || "未获取到对应盘厂信息");
        }
      } catch (e) {
        // axios 已有全局错误处理
      } finally {
        this.queryLoading = false;
      }
    },

    async submitForm() {
      if (!this.$refs.formRef) return;
      const valid = await this.$refs.formRef.validate().catch(() => false);
      if (!valid) {
        this.activeTab = "basic";
        return;
      }

      try {
        (this.formData.equityClassifyList || []).forEach((item) => {
          if (item.startTime === "") throw "请选择签约日期";
          if (item.endTime === "") throw "请选择到期日期";
          if (!this.validateDates(item.startTime, item.endTime)) {
            throw "签约日期不能晚于到期日期";
          }
        });

        const selectedItems = this.classifyList.filter((item) =>
          this.formData.equityClassifyIds.includes(item.id)
        );
        selectedItems.sort((a, b) => a.index - b.index);

        const newData = {
          ...this.formData,
          image:
            this.formData.image && this.formData.image.length
              ? this.formData.image.join(",")
              : "",
          video:
            this.formData.video && this.formData.video.length
              ? this.formData.video.join(",")
              : "",
          equityClassifyIds: selectedItems.map((item) => item.id).join(","),
          equityClassifyList: (this.formData.equityClassifyList || []).map(
            (item) => {
              let extras = {};
              if (item.name === "L1") {
                extras = { appliedLicense: this.formData.usedLicense };
              } else if (item.name === "L2") {
                extras = {
                  ldesignAccount: this.formData.ldesignAccount,
                  qualityInspectionCount: this.formData.checkCount,
                  passCount: this.formData.passCount,
                  unqualifiedQualityInspectionsNum:
                    this.formData.unqualifiedQualityInspectionsNum,
                };
              }
              return {
                ...item,
                ...extras,
                certImage: item.certImage ? item.certImage.join(",") : "",
                endTime: item.endTime
                  ? dayjs(item.endTime).format("YYYY-MM-DD 23:59:59")
                  : null,
                startTime: item.startTime
                  ? dayjs(item.startTime).format("YYYY-MM-DD 00:00:00")
                  : null,
                equityClassifyId: item.id,
                equityClassifyName: item.name,
              };
            }
          ),
          lwsWarehouse: Array.isArray(this.formData.lwsWarehouse)
            ? this.formData.lwsWarehouse.join(",")
            : this.formData.lwsWarehouse,
          authProvince: Array.isArray(this.formData.authCity)
            ? this.formData.authCity[0] || ""
            : "",
          authCity: Array.isArray(this.formData.authCity)
            ? this.formData.authCity[1] || ""
            : this.formData.authCity || "",
          contractList: this.contractList,
        };

        this.formLoading = true;
        if (this.formType === "create") {
          const res = await factoryManageAdd(newData);
          if (res.code == 200) Message.success("新增成功");
        } else {
          const res = await factoryManageUpdate(newData);
          if (res.code == 200) Message.success("修改成功");
        }
        this.dialogVisible = false;
        this.$emit("success");
        this.formLoading = false;
      } catch (e) {
        if (typeof e === "string") Message.warning(e);
        this.formLoading = false;
      }
    },

    validateDates(dateA, dateB) {
      if (!dateA || !dateB) return true;
      return new Date(dateA) <= new Date(dateB);
    },

    /** 兼容后端可能返回的几种 authCity 形式，统一转成 cascader 需要的数组（保持字符串，与 a.json 的 code 类型一致） */
    parseAuthCity(val) {
      if (!val) return [];
      if (Array.isArray(val)) return val.map((v) => String(v));
      return String(val)
        .split(",")
        .map((v) => v.trim())
        .filter(Boolean);
    },

    /** 将逗号分隔的字符串或数组统一解析为数字数组（处理 ws 仓库数据） */
    parseWarehouse(val, fallback = []) {
      if (!val) return fallback;
      const arr = Array.isArray(val) ? val : String(val).split(",");
      return arr.map((v) => Number(v) || v).filter(Boolean);
    },

    /** 统一处理字符串转数组，避免多次三元 split */
    parseStringToArray(val, fallback = []) {
      if (!val) return fallback;
      return Array.isArray(val) ? val : String(val).split(",");
    },

    /** 兼容 Safari 的日期格式转换 */
    parseDateForSafari(dateStr) {
      if (!dateStr) return "";
      const userAgent = navigator.userAgent;
      const isSafari = /Safari/.test(userAgent) && !/Chrome/.test(userAgent);
      return isSafari ? String(dateStr).replace(/-/g, "/") : dateStr;
    },

    /** 解析 a.json 生成静态省市两级选项数据 */
    buildCityOptions() {
      const provinces = areaData["0"] || {};
      const options = [];
      Object.keys(provinces).forEach((provCode) => {
        const provName = provinces[provCode];
        const citiesMap = areaData[`0,${provCode}`] || {};
        const children = Object.keys(citiesMap).map((cityCode) => ({
          value: citiesMap[cityCode],
          label: citiesMap[cityCode],
        }));
        options.push({
          value: provName,
          label: provName,
          children: children.length ? children : undefined,
        });
      });
      return options;
    },
    sumLicense(usedLicenseNum, ableLicenseNum) {
      const used = Number(usedLicenseNum);
      const able = Number(ableLicenseNum);
      if (Number.isNaN(used) && Number.isNaN(able)) return "";
      return (Number.isNaN(used) ? 0 : used) + (Number.isNaN(able) ? 0 : able);
    },
    getRegionList() {
      oaApproverRegionList().then((res) => {
        if (res.code === 200) {
          this.regionOptions = (res.data || []).map((item) => ({
            label: item,
            value: item,
          }));
        }
      });
    },

    upload(e) {
      if (Array.isArray(e)) this.formData.image = [...e];
      else this.formData.image = [...this.formData.image, e];
    },

    uploadVideo(e) {
      if (Array.isArray(e)) this.formData.video = [...e];
      else this.formData.video = [...this.formData.video, e];
    },

    uploadEquity(e, indexof) {
      const next = Array.isArray(e) ? [...e] : [e];
      this.formData.equityClassifyList = this.formData.equityClassifyList.map(
        (item, index) =>
          index == indexof ? { ...item, certImage: next } : item
      );
    },

    resetForm() {
      this.formData = this.buildEmptyForm();
      this.contractList = [];
    },

    handleClose() {
      this.dialogVisible = false;
    },

    handleSort(e) {
      const selectedItems = this.classifyList.filter((item) =>
        e.includes(item.id)
      );
      selectedItems.sort((a, b) => a.index - b.index);

      const newList = [];
      this.classifyList.forEach((classifyItem) => {
        const existingItem = this.formData.equityClassifyList.find(
          (item) => item.id === classifyItem.id
        );
        const selectedItem = selectedItems.find(
          (item) => item.id === classifyItem.id
        );
        if (existingItem) newList.push(existingItem);
        else if (selectedItem)
          newList.push({
            ...selectedItem,
            certImage: [],
            endTime: "",
            startTime: "",
          });
      });
      this.formData.equityClassifyList = newList.filter((item) =>
        e.includes(item.id)
      );
    },

    editoChange(e) {
      this.formData.details = e;
    },

    async getContractList() {
      // 合同列表数据通过 合作伙伴名称旁边的查询信息接口获取，这里只做本地过滤
      let list = this.formData.contractList || [];
      if (this.contractFilter.contractCode) {
        list = list.filter(
          (item) =>
            item.contractCode &&
            item.contractCode.includes(this.contractFilter.contractCode)
        );
      }
      if (
        this.contractFilter.contractLevel !== "" &&
        this.contractFilter.contractLevel !== null
      ) {
        list = list.filter(
          (item) => item.contractLevel === this.contractFilter.contractLevel
        );
      }
      this.contractList = list;
    },
    resetContractSearch() {
      this.contractFilter = {
        contractCode: "",
        contractLevel: "",
      };
      this.getContractList();
    },

    // ===== 合同 预览 =====
    handlePreviewContractUrl(url, titleSuffix) {
      if (!url) {
        Message.warning("暂无合同文件");
        return;
      }

      // 如果不是 PDF 文件，直接新窗口打开（触发浏览器下载或自行预览）
      if (!/\.pdf(\?|#|$)/i.test(url)) {
        window.open(url, "_blank");
        return;
      }

      this.contractPreviewTitle = titleSuffix
        ? `合同预览 - ${titleSuffix}`
        : "合同预览";
      this.contractPreviewUrl = url;
      this.contractPreviewLoading = true;
      this.contractPreviewVisible = true;
    },

    openContractInNewTab() {
      if (!this.contractPreviewUrl) return;
      window.open(this.contractPreviewUrl, "_blank");
    },
  },
};
</script>
<style scoped>
.video_box {
  margin-left: 3%;
  margin-bottom: 10px;
}
.video_icon {
  cursor: pointer;
  margin-top: 0.5%;
  margin-left: 10px;
}
.video_span {
  width: 80px;
  margin-left: 10px;
}
.details_box {
  margin-right: 10%;
  max-width: 100%;
  overflow: hidden;
}
.details_box p img {
  max-width: 100%;
  height: auto;
  object-fit: contain;
}
:deep(.el-input__inner) {
  text-align: left;
}
.auth-block {
  /* border: 1px dashed #f56c6c; */
  padding: 16px 0 0;
  margin: 10px 0;
  position: relative;
}
.auth-block-title {
  position: absolute;
  right: -50px;
  top: 50%;
  transform: translateY(-50%);
  color: #f56c6c;
  font-size: 12px;
  writing-mode: vertical-rl;
}
.l2-block {
  border-color: #e6a23c;
}
.l2-block .auth-block-title {
  color: #e6a23c;
}
.performance-tabs {
  margin-bottom: 10px;
}
.marginLeft10 {
  margin-left: 10px;
}
.marginTop10 {
  margin-top: 10px;
}
.marginBottom10 {
  margin-bottom: 10px;
}
.flex {
  display: flex;
}
.align-items {
  align-items: center;
}
.contract-code-link {
  color: #409eff;
  cursor: pointer;
}
.contract-code-link:hover {
  text-decoration: underline;
}
.contract-preview-body {
  width: 100%;
  height: 70vh;
  background: #f5f7fa;
}
.contract-preview-iframe {
  width: 100%;
  height: 100%;
  border: 0;
  background: #fff;
}
.contract-preview-empty {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #909399;
  font-size: 14px;
}
:deep(.contract-preview-dialog .el-dialog__body) {
  padding: 10px 20px;
}
</style>
